import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {
  CreateObservationTypeGroup,
  ObservationGroupTypeDto,
  ObservationTypeGroup
} from '../../shared/models/observation-group';
import {environment} from '../../../environments/environment';
import {HttpErrorHandler} from '../../http.error.handler';
import {catchError, map} from 'rxjs/operators';
import {ObservationType, ObservationTypeDto} from '../../shared/models/observation-type';
import {JsonApiResponse} from '../../shared/models/JsonApiResponse';
import {firstValueFrom} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ObservationManagementService {

  constructor(private readonly http: HttpClient) {
  }

  getObservationTypeGroups() {
    return firstValueFrom(
      this.http.get<JsonApiResponse<ObservationTypeGroup[]>>(`${environment.services.service}v1/observation-type-group/list`)
      .pipe(
        catchError(HttpErrorHandler.handleError),
        map(response => response.data)
      )
    );
  }

  getObservationTypeGroup(id: number) {
    return firstValueFrom(
      this.http.get<JsonApiResponse<ObservationGroupTypeDto>>(`${environment.services.service}v1/observation-type-group/${id}`)
        .pipe(
          catchError(HttpErrorHandler.handleError),
          map(response => response.data),
        )
    );
  }

  getObservationTypesForTypeGroup(id: number) {
    return firstValueFrom(
      this.http.get<JsonApiResponse<ObservationTypeDto[]>>(`${environment.services.service}v1/observation-type-group/${id}/observation-type/list`)
        .pipe(
          catchError(HttpErrorHandler.handleError),
          map(response => response.data),
        )
    );
  }

  updateObservationTypeGroup(id: number, data: ObservationGroupTypeDto): Promise<JsonApiResponse<ObservationTypeGroup>> {
    const requestUrl = `${environment.services.service}v1/observation-type-group/${id}`;

    return firstValueFrom(
      this.http.patch<JsonApiResponse<ObservationTypeGroup>>(requestUrl, data)
        .pipe(
          catchError(HttpErrorHandler.handleError)
        )
    );
  }

  createObservationTypeGroup(data: CreateObservationTypeGroup): Promise<JsonApiResponse<ObservationTypeGroup>> {
    const requestUrl = `${environment.services.service}v1/observation-type-group`;

    return firstValueFrom(
      this.http.post<JsonApiResponse<ObservationTypeGroup>>(requestUrl, data)
        .pipe(
          catchError(HttpErrorHandler.handleError)
        )
    );
  }

  deleteObservationTypeGroup(id: number): Promise<void> {
    const requestUrl = `${environment.services.service}v1/observation-type-group/${id}`;

    return firstValueFrom(
      this.http.delete<void>(requestUrl)
        .pipe(
          catchError(HttpErrorHandler.handleError)
        )
    );
  }

  updateObservationType(groupId: number, id: number, observationTypeDto: ObservationTypeDto): Promise<JsonApiResponse<ObservationType>> {
    const requestUrl = `${environment.services.service}v1/observation-type-group/${groupId}/type/${id}`;

    return firstValueFrom(
      this.http.patch<JsonApiResponse<ObservationType>>(requestUrl, observationTypeDto)
        .pipe(
          catchError(HttpErrorHandler.handleError)
        )
    );
  }

  createObservationType(groupId: number, observationTypeDto: ObservationTypeDto): Promise<JsonApiResponse<ObservationType>> {
    const requestUrl = `${environment.services.service}v1/observation-type-group/${groupId}/type`;

    return firstValueFrom(
      this.http.post<JsonApiResponse<ObservationType>>(requestUrl, observationTypeDto)
        .pipe(
          catchError(HttpErrorHandler.handleError)
        )
    );
  }

  deleteObservationType(groupId: number, id: number): Promise<void> {
    const requestUrl = `${environment.services.service}v1/observation-type-group/${groupId}/type/${id}`;

    return firstValueFrom(
      this.http.delete<void>(requestUrl)
        .pipe(
          catchError(HttpErrorHandler.handleError)
        )
    );
  }
}
